import React from 'react';
import XLSXDownload from '../../common/XLSXDownload';
import { RowData, Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { ButtonGroup } from 'react-bootstrap';

type Props = {
	table: Table<RowData>;
	download?: {
		prepareDownload: () => void;
		fileName: string;
		title: string;
	};
	paginationOptions?: number[];
};
const TableFooter = ({ table, download, paginationOptions = [10, 50] }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="d-flex justify-content-between">
			<div className="col-4 justify-content-start d-flex">
				{download !== undefined ? (
					<XLSXDownload
						className="me-3"
						getData={download.prepareDownload}
						fileName={download.fileName}
						title={download.title}
						icon
					/>
				) : null}
				<div className="align-items-center ms-1">
					<select
						className="form-select me-2"
						value={table.getState().pagination.pageSize}
						onChange={(e) => {
							if (e.target.value === 'ALL') {
								table.setPageSize(table.getRowCount());
							} else {
								table.setPageSize(Number(e.target.value));
							}
						}}>
						<option value="ALL">Alle</option>
						{paginationOptions.map((pageSize) => (
							<option key={pageSize} value={pageSize}>
								{`${t('table.show')} ${pageSize}`}
							</option>
						))}
					</select>
				</div>
			</div>
			<div className="col-3 justify-content-center d-flex">
				{`${table.getState().pagination.pageIndex + 1} ${t('table.of')} ${(table.getPageCount() || 1).toLocaleString()}`}
			</div>
			<div className="col-5 d-flex justify-content-end">
				{table.getPageCount() > 1 ? (
					<>
						<div className="align-items-center row mx-2">
							<div className="col-auto">{`${t('table.gotoPage')}:`}</div>
							<div className="col-auto">
								<input
									className="form-control"
									type="number"
									max={table.getPageCount()}
									min={1}
									defaultValue={table.getState().pagination.pageIndex + 1 || 1}
									onChange={(e) => {
										const page = e.target.value ? Number(e.target.value) - 1 : 0;
										table.setPagination((prevState) => ({
											...prevState,
											pageIndex: page,
										}));
									}}
								/>
							</div>
						</div>
						<ButtonGroup>
							<button
								className="btn btn-outline-primary"
								type="button"
								onClick={table.previousPage}
								disabled={!table.getCanPreviousPage()}>
								{t('table.previous')}
							</button>
							<button
								className="btn btn-outline-primary"
								type="button"
								onClick={table.nextPage}
								disabled={!table.getCanNextPage()}>
								{t('table.next')}
							</button>
						</ButtonGroup>
					</>
				) : null}
			</div>
		</div>
	);
};

export default TableFooter;
